!function (t, r) {
    if ("object" == typeof exports && "object" == typeof module) module.exports = r(); else if ("function" == typeof define && define.amd) define([], r); else {
        var e = r();
        for (var n in e) ("object" == typeof exports ? exports : t)[n] = e[n]
    }
}("undefined" != typeof self ? self : this, function () {
    return n = {}, o.m = e = [function (t, r, e) {
        "use strict";
        e.r(r);

        function o(t) {
            return parseInt(t.repeat(3 - t.length), 16)
        }

        function n(t, r) {
            var e = 1 < arguments.length && void 0 !== r ? r : 1, n = i.exec(t) || u.exec(t);
            return n ? { r: o(n[1]), g: o(n[2]), b: o(n[3]), a: e } : void 0
        }

        var i = new RegExp(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i),
            u = new RegExp(/^#?([a-f\d])([a-f\d])([a-f\d])$/i), c = function (t) {
                var r = t.r, e = t.g, n = t.b, o = t.a, i = void 0 === o ? 1 : o;
                return 1 !== i ? "rgba(".concat(r, ", ").concat(e, ", ").concat(n, ", ").concat(i, ")") : "rgb(".concat(r, ", ").concat(e, ", ").concat(n, ")")
            };

        function a(t) {
            return function (t) {
                if (Array.isArray(t)) return t
            }(t) || function (t) {
                if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t)
            }(t) || function () {
                throw new TypeError("Invalid attempt to destructure non-iterable instance")
            }()
        }

        function f(t) {
            return Number(t)
        }

        var l = new RegExp(/\d+/g), s = [{ regexps: [i, u], handler: n }, {
            regexps: [l], handler: function (t) {
                var r = a(t.match(l)), e = r[0], n = r[1], o = r[2], i = r.slice(3).join(".") || 1;
                return function (t, r, e, n) {
                    return [t, r, e].every(function (t) {
                        return 0 <= t && t <= 255
                    }) && (!n || 0 <= n && n <= 1)
                }(e, n, o, i) ? { r: f(e), g: f(n), b: f(o), a: f(i) } : void 0
            }
        }], p = function (r, t) {
            var e = s.find(function (t) {
                return t.regexps.some(function (t) {
                    return t.test(r)
                })
            });
            if (!e) throw new Error("Stop color - ".concat(r, " does not follow one of the accepted formats Hex / Rgb / Rgba "));
            var n = e.handler(r, t);
            return c(n)
        }, b = function (t) {
            return null != t
        }, y = function (t, r, e) {
            return t < (1 < arguments.length && void 0 !== r ? r : 0) ? 360 + t : (2 < arguments.length && void 0 !== e ? e : 360) < t ? t - 360 : t
        };

        function d(t, r) {
            return function (t) {
                if (Array.isArray(t)) return t
            }(t) || function (t, r) {
                if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
                var e = [], n = !0, o = !1, i = void 0;
                try {
                    for (var u, c = t[Symbol.iterator](); !(n = (u = c.next()).done) && (e.push(u.value), !r || e.length !== r); n = !0) ;
                } catch (t) {
                    o = !0, i = t
                } finally {
                    try {
                        n || null == c.return || c.return()
                    } finally {
                        if (o) throw i
                    }
                }
                return e
            }(t, r) || function () {
                throw new TypeError("Invalid attempt to destructure non-iterable instance")
            }()
        }

        function g(t) {
            return Number("".concat(t).trim().endsWith("%") ? t.trim().replace("%", "") : t)
        }

        function v(t) {
            var r = t.getAttribute(P);
            if (r) {
                var e = t.getAttribute(x);
                return p(r, e)
            }
            var n = function (t) {
                var r = document.createElement("div");
                return r.setAttribute("style", t), r.style
            }(t.getAttribute(w)), o = n[P], i = n[x];
            return o ? p(o, i) : void 0
        }

        function m(t) {
            return t <= 0 || Math.abs(t) <= M ? 0 : t
        }

        function O(t) {
            return { x: m(Math.cos(t)), y: m(Math.sin(t)) }
        }

        function h(t) {
            return t * Math.PI / 180
        }

        var j = function (t) {
                var r = t.x1, e = t.x2, n = t.y1, o = t.y2, i = d([r, e, n, o].map(g), 4);
                r = i[0], e = i[1], n = i[2];
                var u = e - r, c = (o = i[3]) - n;
                if (0 == c) return e < r ? 270 : 90;
                if (0 == u) return o < n ? 0 : 180;
                var a = Math.atan2(c, u);
                return y(180 * a / Math.PI + 90)
            }, w = "style", P = "stop-color", x = "stop-opacity", S = "offset", A = ["x1", "x2", "y1", "y2"],
            E = function (t) {
                return Array.from(t.querySelectorAll("stop")).map(function (t) {
                    var r = N(t.getAttribute(S)), e = v(t);
                    return { offset: Number(r), color: e }
                })
            }, M = Math.pow(2, -52), D = function (t) {
                var r = (360 - (0 < arguments.length && void 0 !== t ? t : 0)) % 360;
                return { startPoint: O(h(90 - r)), endPoint: O(h(270 - r)) }
            }, N = function (t) {
                return (t = t.toString().trim()).endsWith("%") ? Number(t.replace("%", "")) : 100 * Number(t)
            };

        function _(r, t) {
            var e = Object.keys(r);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(r);
                t && (n = n.filter(function (t) {
                    return Object.getOwnPropertyDescriptor(r, t).enumerable
                })), e.push.apply(e, n)
            }
            return e
        }

        function G(t, r, e) {
            return r in t ? Object.defineProperty(t, r, {
                value: e,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[r] = e, t
        }

        var I = new DOMParser;

        function R(t) {
            return (R = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                return typeof t
            } : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
            })(t)
        }

        function k(r, t) {
            var e = Object.keys(r);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(r);
                t && (n = n.filter(function (t) {
                    return Object.getOwnPropertyDescriptor(r, t).enumerable
                })), e.push.apply(e, n)
            }
            return e
        }

        function T(t, r, e) {
            return r in t ? Object.defineProperty(t, r, {
                value: e,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[r] = e, t
        }

        var C = {
            string: function (t) {
                var r = I.parseFromString(t, "image/svg+xml").querySelector("linearGradient");
                if (!r) throw new Error("Couldn't parse svg string into linearGradient SVGElement");
                return function (r) {
                    for (var t = 1; t < arguments.length; t++) {
                        var e = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? _(e, !0).forEach(function (t) {
                            G(r, t, e[t])
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e)) : _(e).forEach(function (t) {
                            Object.defineProperty(r, t, Object.getOwnPropertyDescriptor(e, t))
                        })
                    }
                    return r
                }({}, function (e) {
                    return A.reduce(function (t, r) {
                        return Object.assign(t, G({}, r, e.getAttribute(r)))
                    }, {})
                }(r), {
                    stops: E(r).filter(function (t) {
                        var r = t.offset, e = t.color;
                        return b(r) && b(e)
                    })
                })
            }, object: function (t) {
                return function (r) {
                    for (var t = 1; t < arguments.length; t++) {
                        var e = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? k(e, !0).forEach(function (t) {
                            T(r, t, e[t])
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e)) : k(e).forEach(function (t) {
                            Object.defineProperty(r, t, Object.getOwnPropertyDescriptor(e, t))
                        })
                    }
                    return r
                }({}, t, {
                    stops: t.stops.map(function (t) {
                        var r = t.offset, e = t.color, n = t.opacity;
                        return { offset: N(r), color: p(e, n) }
                    })
                })
            }
        }, q = {
            getBackground: function (t) {
                var r = R(t), e = C[r];
                if (!e) throw new Error("Cannot parse non JSON / SVG String input");
                var n = (t = e(t)).stops || t.children, o = j(t);
                return {
                    angle: o, background: function (t) {
                        var r = t.angle, e = t.stops;
                        return 1 === e.length ? e[0].color : "linear-gradient(".concat(r, "deg, ").concat(e.map(function (t) {
                            return "".concat(t.color, " ").concat(t.offset, "%")
                        }).join(", "), ")")
                    }({ angle: o, stops: n })
                }
            }, getGradientCords: function (t) {
                var r = D(t), e = r.startPoint, n = r.endPoint;
                return { x1: e.x, y1: e.y, x2: n.x, y2: n.y }
            }
        };
        r.default = q
    }], o.c = n, o.d = function (t, r, e) {
        o.o(t, r) || Object.defineProperty(t, r, { enumerable: !0, get: e })
    }, o.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 })
    }, o.t = function (r, t) {
        if (1 & t && (r = o(r)), 8 & t) return r;
        if (4 & t && "object" == typeof r && r && r.__esModule) return r;
        var e = Object.create(null);
        if (o.r(e), Object.defineProperty(e, "default", {
            enumerable: !0,
            value: r
        }), 2 & t && "string" != typeof r) for (var n in r) o.d(e, n, function (t) {
            return r[t]
        }.bind(null, n));
        return e
    }, o.n = function (t) {
        var r = t && t.__esModule ? function () {
            return t.default
        } : function () {
            return t
        };
        return o.d(r, "a", r), r
    }, o.o = function (t, r) {
        return Object.prototype.hasOwnProperty.call(t, r)
    }, o.p = "", o(o.s = 0);

    function o(t) {
        if (n[t]) return n[t].exports;
        var r = n[t] = { i: t, l: !1, exports: {} };
        return e[t].call(r.exports, r, r.exports, o), r.l = !0, r.exports
    }

    var e, n
});
//# sourceMappingURL=index.js.map